import { Dictionary } from 'lodash';
import { useMemo } from 'react';
import { Currency, CurrencyMapping } from 'api/account';
import { useCurrencyMappingListQuery } from 'queries/account';

export interface CurrencyMap {
  default: Currency;
  all: Dictionary<CurrencyMapping>;
  enabled: Dictionary<CurrencyMapping>;
}

export const useAccountCurrency = (): CurrencyMap | undefined => {
  const { data: currencyMappingList } = useCurrencyMappingListQuery();

  const currencyCache = useMemo(() => {
    if (currencyMappingList == null || currencyMappingList.length === 0) {
      return undefined;
    }

    const temp = {} as CurrencyMap;

    currencyMappingList.forEach((currencyMapping) => {
      if (currencyMapping.defaultCurrency) {
        temp.default = currencyMapping.currency;
      }

      if (currencyMapping.enabled) {
        temp.enabled = {
          ...temp.enabled,
          [currencyMapping.currency.currencyCode]: currencyMapping,
        };
      }

      temp.all = {
        ...temp.all,
        [currencyMapping.currency.currencyCode]: currencyMapping,
      };
    });

    return temp;
  }, [currencyMappingList]);

  return currencyCache;
};
